import React, { useEffect, useState } from "react"

// Utilities
import { handleBannerSliderType } from "./utilities/formatBannerData"

// Data
import BANNER_DATA from "../../../static/data/banners"
import lazyLoad from "../../utilities/handleLazyLoad"

// Components
import BannerItem from "./BannerItem"
const Slider = lazyLoad(() => import("../Sliders/Slider"))

/**
 * @param type - the type of the banner
 * @param country - the selected country
 * */
const Banners = ({ type, country }) => {
  const sliderType = handleBannerSliderType(type, country)

  /*==============================================
    HANDLE SLIDER TYPE
    - worldwide or US/UK/Canada shop for homepage
    - type for the others
    - needed for setting whether it's slider or not
   ================================================ */
  const isSlider = sliderType !== "apparel" && sliderType !== "merchandise" && sliderType !== "bundles"

  /*=====================================
    HANDLE BANNER DATA
    - show those banners from the selected type
    that are set as active
   ==================================== */
  const [bannerData, setBannerData] = useState([])
  useEffect(() => {
    if (!sliderType.length) return

    let newBanner = []
    BANNER_DATA[sliderType].forEach(banner => {
      if (banner.isActive) {
        newBanner = [...newBanner, banner]
      }
    })
    setBannerData(newBanner)
  }, [sliderType])

  /*=====================================
    HANDLE BANNER ORDER
    - show the banners randomly
   ==================================== */
  const [bannersOrder, setBannersOrder] = useState([])

  useEffect(() => {
    let order = Array.from(Array(bannerData.length).keys())

    for (let i = order.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[order[i], order[j]] = [order[j], order[i]]
    }
    setBannersOrder(order)
  }, [bannerData])

  return (
    <Slider showIndicators={isSlider} showArrows={isSlider} autoPlay={isSlider} notSwipeable={false} showThumbs={false}>
      {bannersOrder.map(index => (
        <BannerItem
          key={`banner-${index}`}
          modifierClass={bannerData[index]?.modifierClass || ""}
          columns={bannerData[index]?.columns || ""}
          rockYourLife={bannerData[index]?.rockYourLife || false}
          rockAndRestore={bannerData[index]?.rockAndRestore || false}
          imgSrc={bannerData[index]?.imgSrc || ""}
          imgWidth={bannerData[index]?.imgWidth || ""}
          imgHeight={bannerData[index]?.imgHeight || ""}
          title={bannerData[index]?.title || ""}
          description={bannerData[index]?.description || ""}
          isHome={bannerData[index]?.isHome || ""}
          link={bannerData[index]?.link || ""}
          categoryLink={bannerData[index]?.categoryLink || ""}
          category={bannerData[index]?.category || ""}
          isDecember={bannerData[index]?.isDecember || false}
          isDecember2={bannerData[index]?.isDecember2 || false}
        />
      ))}
    </Slider>
  )
}
export default Banners
